import dashboard from './dashboard';
import widget from './widget';
import application from './application';
import forms from './forms';
import elements from './elements';
import pages from './pages';
import utilities from './utilities';
import support from './support';
import other from './other';
import menus from './menus';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    // items: [dashboard, menus, widget, application, forms, elements, pages, utilities, support, other]
    items: [menus]
};

export default menuItems;
